export const BASE_URL = "http://localhost:3000";

export const AUTH_URL = `/api/auth`;

export const USER_LOGIN_URL = `${AUTH_URL}/login`;
export const GOOGLE_LOGIN_URL = `${AUTH_URL}/glogin`;
export const USER_REGISTER_URL = `${AUTH_URL}/register`;
export const ME_USER_URL = `${AUTH_URL}/me`;
export const USER_LOGOUT_URL = `${AUTH_URL}/logout`;
export const RESET_PASSWORD = `${AUTH_URL}/reset_password`;
export const REQUEST_RESET_PWD = `${AUTH_URL}/request_password_reset`;
export const DEACTIVATE_SELF = `${AUTH_URL}/deactivate_self`;

export const USER_URL = `${BASE_URL}/api/user`;
export const ALL_USERS = `${USER_URL}/all_users`;
export const CREATE_USER = `${USER_URL}/create_user`;
export const BREAK_DOWN = `${USER_URL}/breakdown`;
export const UPDATE_PENDING_USER = `${USER_URL}/update_pending_user`;
export const ABOUT_ME_URL = `${USER_URL}/aboutme`;
export const UPDATE_ME_URL = `${USER_URL}/updateme`;

export const INVITE_URL = `${BASE_URL}/api/invitation`;

export const SEND_INVITE = `${INVITE_URL}/send_invite`;
export const CREATE_INVITE_LINK = `${INVITE_URL}/create_invite_link`;
export const RESEND_INVITE = `${INVITE_URL}/resend_invite`;
export const DELETE_INVITE = `${INVITE_URL}/delete_invite`;
export const ALL_INVITES = `${INVITE_URL}/all_invites`;
export const INVITE_BREAK_DOWN = `${INVITE_URL}/breakdown`;
export const PROCESS_INVITE = `${INVITE_URL}/process_invite`;
export const CHECK_INVITE = `${INVITE_URL}/check_invite`;
export const LOAD_INVITE = `${INVITE_URL}/details`;

export const CHANGE_REQ_URL = `${BASE_URL}/api/change_request`;

export const ALL_CHANGE_REQ = `${CHANGE_REQ_URL}/all_requests`;
export const UPDATE_CHANGE_REQ = `${CHANGE_REQ_URL}/update_change_request`;
export const UPDATE_ROLE = `${CHANGE_REQ_URL}/request_change/role`;

export const SETTINGS_URL = `${BASE_URL}/api/settings`;

export const GET_SETTINGS = `${SETTINGS_URL}/get_settings`;
export const SET_SETTINGS = `${SETTINGS_URL}/set_settings`;
